<template>
  <DatatableReportV3
    title="Sales Tax"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "completed_on",
            title: "Completed",
            filterName: "finalized_at",
            searchable: false
          },
          { data: "invoice" },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "job" },
          { data: "location_name", title: "Location Name" },
          { data: "address", orderable: false },
          {
            data: "tax_zone_name",
            title: "Tax Zone Name",
            searchable: false
          },
          { data: "tax_rate", title: "Tax Rate", searchable: false },
          {
            data: "sales_tax",
            title: "Sales Tax",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.sales_tax,
            searchable: false
          },
          {
            data: "invoice_total",
            title: "Invoice Total",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoice_total,
            searchable: false
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Sales Tax" });
  }
};
</script>

<style lang="scss" scoped></style>
